module.exports = __webpack_public_path__ + "img/onboarding.e967e66c.png";